// DEPLOY: /var/www/woody.wtf/frontend/src/chart/theme.js
// chart.ninja chart engine: colours come from the site's CSS variables (index.css), so the chart
// follows the user's theme. Candle colours/style come from --candle-* (theme defaults, or the
// user's own choices from Settings -> Appearance, set inline by appearance.js).
export function readTheme(el) {
  const s = getComputedStyle(el || document.documentElement);
  const v = (name, fallback) => s.getPropertyValue(name).trim() || fallback;
  const text = v('--text', '#E6EAF0');
  const wick = v('--candle-wick', 'match');
  return {
    bg:     v('--surface', '#141922'),
    grid:   v('--border', '#262F3D'),
    text,
    muted:  v('--text-muted', '#8E99AB'),
    accent: v('--accent', '#F5B83D'),
    onAccent: v('--on-accent', '#0B0E13'),   // text on an accent-coloured tag
    up:     v('--candle-up', v('--up', '#2BC48A')),
    down:   v('--candle-down', v('--down', '#F2617A')),
    body:   v('--candle-body', 'solid'),   // solid | hollow | hollow_up
    wick,                                   // 'match' = each candle's own colour
    candleLine: wick === 'match' ? text : wick,   // pre-market candle + one-colour wicks/outlines
    live:   v('--live', '#B07CFF'),         // today's unconfirmed candle until the EOD bar arrives
    font:   "11px 'JetBrains Mono', monospace",
  };
}

// Re-read the theme and redraw whenever Settings -> Appearance (or Auto + the device) changes it.
export function followTheme(engine, host, redraw) {
  const on = () => { engine.theme = readTheme(host); redraw(); };
  window.addEventListener('appearancechange', on);
  return () => window.removeEventListener('appearancechange', on);
}
